import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return (constraint) =>
    present(
      repository
        .removeConstraint(constraint)
        .then(() => constraint)
        .catch(() => Promise.reject(constraint)),
    );
}

export type { Interactor };

export { createInteractor };
